import { format } from "date-fns";
import { cn } from "@/utils/utils";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FormField from "../common/FormField";
import SelectDiscountDate from "../../pages/createDiscount/componets/SelectDiscountDate";
import useSelectDate from "@/hooks/useSelectDate";
import { DateRange } from "react-day-picker";
import { useEffect } from "react";

interface DateFieldProps {
  error?: string;
  isMobile: boolean;
  date: {
    from: Date;
    to: Date;
  };
  onDateChange: (date: DateRange | undefined) => void;
}

const DateField = ({ error, isMobile, date, onDateChange }: DateFieldProps) => {
  const {
    handleOpenUserMenu,
    date: dateSelect,
    ...propsDate
  } = useSelectDate();

  useEffect(() => {
    if (date) {
      propsDate.setDate(date);
    }
  }, [date]);

  return (
    <FormField
      label="Valid Date"
      id="validDate"
      name="validDate"
      value=""
      onChange={() => {}}
      error={error}
    >
      <SelectDiscountDate
        {...propsDate}
        date={dateSelect}
        numberOfMonths={isMobile ? 1 : 2}
        contentStyle={{
          width: isMobile ? "var(--radix-popover-trigger-width)" : "",
        }}
        anchor={
          <div
            onClick={
              propsDate.anchorElUser
                ? propsDate.handleCloseUserMenu
                : handleOpenUserMenu
            }
            className="flex h-[48px] w-full items-center justify-between rounded-lg border border-[#E2E8F0] px-3 text-sm"
          >
            <p className={cn("font-normal text-[#020617]")}>
              {!date?.from && !date?.to ? (
                <span className="text-neutral-400">Select date</span>
              ) : (
                `${date?.from ? format(date.from, "yyyy/MM/dd") : ""} - ${
                  date?.to ? format(date.to, "yyyy/MM/dd") : ""
                }`
              )}
            </p>
            <KeyboardArrowDownIcon
              sx={{
                color: "#94A3B8",
              }}
            />
          </div>
        }
        setDateSelect={onDateChange}
      />
    </FormField>
  );
};

export default DateField;
